import React from 'react';
import { ClockIcon, AlertTriangleIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
interface CountdownProps {
  label: string;
  note?: string;
  progress?: number;
}
export function Countdown({
  label,
  note,
  progress
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    unit: 'hs'
  }, {
    value: minutes,
    unit: 'min'
  }, {
    value: seconds,
    unit: 'seg'
  }];
  return <div className="rounded-2xl border border-ink-700 bg-ink-900 p-6 text-center sm:p-8" data-id="element-60" data-mp="3c48rimubz9ii">
      <p className="flex items-center justify-center gap-2 font-display text-[11px] font-700 uppercase tracking-[0.24em] text-gold" data-id="element-61" data-mp="3gyw71w7cwtky">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-62" data-mp="3729m77f162ix" />
        {label}
      </p>

      <div className="mt-5 flex items-center justify-center gap-2 sm:gap-3" data-id="element-63" data-mp="10cbrzdzcmvd7">
        {units.map((item, index) => <React.Fragment key={item.unit} data-id="element-64" data-mp="15by6dqqwyhnl" data-mpi={index}>
            <div className="min-w-[72px] rounded-lg bg-ink-950 px-3 py-3 sm:min-w-[92px]" data-id="element-65" data-mp="15an45vd49hyl">
              <span className="block font-display text-3xl font-900 tabular-nums text-white sm:text-4xl" data-id="element-66" data-mp="xzlsbpzbewvh">
                {item.value}
              </span>
              <span className="mt-1 block text-[11px] uppercase tracking-widest text-slate-500" data-id="element-67" data-mp="17rhp8xpo0gy4">
                {item.unit}
              </span>
            </div>
            {index < units.length - 1 && <span aria-hidden="true" className="font-display text-2xl text-ink-600" data-id="element-68" data-mp="f1ivip0izvn4">
                :
              </span>}
          </React.Fragment>)}
      </div>

      {note && <p className="mt-5 flex items-center justify-center gap-2 text-sm text-slate-400" data-id="element-69" data-mp="o38womk7m8y3">
          <AlertTriangleIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-70" data-mp="k15l7xxjj4ct" />
          {note}
        </p>}

      {typeof progress === 'number' && <div className="mx-auto mt-6 max-w-md text-left" data-id="element-71" data-mp="1zk0bpp6ivgge">
          <div className="flex items-center justify-between text-xs text-slate-400" data-id="element-72" data-mp="1vfsk9k8ojmeh">
            <span data-id="element-73" data-mp="s6g1l55metdy">Cupos al precio de lanzamiento</span>
            <span className="font-600 text-white" data-id="element-74" data-mp="s80wivvukecc">{progress}% tomados</span>
          </div>
          <div className="mt-2 h-2 overflow-hidden rounded-full bg-ink-950" role="progressbar" aria-valuenow={progress} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos al precio de lanzamiento" data-id="element-75" data-mp="x6uasqiyk9dk">
            <div className="h-full rounded-full bg-alert" style={{
          width: `${progress}%`
        }} data-id="element-76" data-mp="9h01gixul2y2" />
          </div>
        </div>}
    </div>;
}